import { render } from "./home.vue?vue&type=template&id=0fb7ef0a"
const script = {}

import exportComponent from "F:\\desktop2025\\myugcollege\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__